import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { enabledSelector } from 'selectors/testTarget/offers/carouselOnPLPNthCategory/enabled/enabledSelector';

const showCarouselOnPLPNthCategorySelector = createSelector(isTestTargetReadySelector, enabledSelector, (testReady, enabled) => ({
    enabled: testReady && enabled === true
}));

export { showCarouselOnPLPNthCategorySelector };
